{
    "DirectoryList_Column_Description": "Beschreibung",
    "DirectoryList_Column_TelephoneNumber": "Telefonnummer",
    "DirectoryList_Add_Disabled_SelectTelSys": "Wählen Sie einen Telefonieserver aus, um einen Verzeichniseintrag hinzuzufügen.",
    "DirectoryList_Add_Disabled_NoTelephonyFilter": "Deaktivieren Sie den Filter „Kein Telefonieserver“, um einen Verzeichniseintrag hinzuzufügen.",
    "NAME": "DirectoryListLanguage"
}